import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '='
    },
    template: `
        <form-wrapper form="vm.form">
            <form-row error="vm.form.errors.pointsPerPeriod">
                <label class="label">{{ 'licence.Points per period' | translate }} *</label>
                <div class="items">
                    <input ng-model="vm.form.model.pointsPerPeriod" type="text" class="form-control">
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row error="vm.form.errors.acquiringDate">
                <label class="label">{{ 'licence.Acquiring deadline' | translate }} *</label>
                <div class="items">
                    <datepicker-api ng-model="vm.form.model.acquiringDate" ng-disabled="vm.disableEditing"></datepicker-api>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row error="vm.form.errors.enteringDate">
                <label class="label">{{ 'licence.Entering deadline' | translate }} *</label>
                <div class="items">
                    <datepicker-api ng-model="vm.form.model.enteringDate" ng-disabled="vm.disableEditing"></datepicker-api>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
        </form-wrapper>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/manage/settings/licences/periods/form/index.js